import { Amplify } from 'aws-amplify';

export const COGNITO_CLIENT_OVERRIDE_STORAGE_KEY = 'manage.cognitoClientIdOverride';

export const applyCognitoClientOverride = (clientId: string | undefined): void => {
    if (!clientId) {
        sessionStorage.removeItem(COGNITO_CLIENT_OVERRIDE_STORAGE_KEY);
        return;
    }

    // Lets index.tsx boot Amplify with the same client on callback/refresh.
    sessionStorage.setItem(COGNITO_CLIENT_OVERRIDE_STORAGE_KEY, clientId);

    const amplifyConfig = Amplify.getConfig();
    const cognitoConfig = amplifyConfig.Auth?.Cognito;
    if (!cognitoConfig) {
        return;
    }

    Amplify.configure({
        ...amplifyConfig,
        Auth: {
            ...amplifyConfig.Auth,
            Cognito: {
                ...(cognitoConfig as any),
                userPoolClientId: clientId,
            },
        },
    });
};